import React from "react";
import { Table } from "reactstrap";
import PropTypes from "prop-types";

import WatchListEntryTableRow from "./watch-list-entry-table-row";
import { watchListEntryType } from "../../../../prop-types";
import "./watchListEntriesTable.css";

const WatchListEntriesTable = ({ watchListEntries, ...rest }) => {
  const rows = watchListEntries.map((entry) => (
    <WatchListEntryTableRow {...rest} key={entry.id} watchListEntry={entry} />
  ));

  return (
      <Table className="high-risk-countries-table">
        <tbody>{rows}</tbody>
      </Table>
  );
};

WatchListEntriesTable.propTypes = {
  watchListEntries: PropTypes.arrayOf(watchListEntryType).isRequired,
};

export default WatchListEntriesTable;



// WEBPACK FOOTER //
// ./src/features/watch-list-entry-high-risk-country/components/watch-list-entries-table/WatchListEntriesTable.jsx